import { useCallback } from "react";
import { useDashboardEditorContext } from "../../../../../../hook/context/editor";
import { useGUIEditorContext } from "../../../../../../hook/context/gui";

export const useLayerSwapEncodingCallback = (position: number) => {
  const editor = useDashboardEditorContext();
  const { block } = useGUIEditorContext();
  return useCallback(() => {
    if (!block) return;

    const layer = block.config.layers[position];
    if (!layer) return;

    const updatedLayer = structuredClone({
      ...layer,
      encoding: {
        ...layer.encoding,
        x: layer.encoding.y,
        y: layer.encoding.x,
      },
      rule: {
        ...layer.rule,
        x: layer.rule?.y ?? [
          { value: null, label: null },
          { value: null, label: null },
        ],
        y: layer.rule?.x ?? [
          { value: null, label: null },
          { value: null, label: null },
        ],
      },
      zoom: {
        ...layer.zoom,
        x: layer.zoom?.y ?? { min: null, max: null },
        y: layer.zoom?.x ?? { min: null, max: null },
      },
    });

    void editor?.updateBlock({
      ...block,
      config: {
        ...block.config,
        layers: block.config.layers.map((layer, i) => (i === position ? updatedLayer : layer)),
      },
    });
  }, [block, editor, position]);
};
